import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@material-ui/core";

export const ModalComentario = (props) => {
  const [descripcion] = useState(!!props.nota ? props.nota.comentario : "");

  const [nombreUsuario] = useState(
    !!props.nota ? props.nota.nombreUsuario : ""
  );

  const [error] = useState(false);

  return (
    <Dialog fullWidth maxWidth="sm" open={props.open} onClose={props.close}>
      <DialogTitle>{props.titulo}</DialogTitle>
      <DialogContent>
        {/* <ValidatorForm onSubmit={{onSubmit}}> */}
        <Grid container spacing={2} style={{ margin: "2rem 0" }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              multiline
              rows={4}
              label="descripcion"
              disabled
              name="descripcion"
              value={descripcion}
              error={error}
              helperText={error && "Este campo es requerido"}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              variant="outlined"
              multiline
              label="Usuario"
              disabled
              name="nombreUsuario"
              value={nombreUsuario}
            />
          </Grid>
        </Grid>
        <div
          style={{
            margin: "1rem 0",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
          }}
        >
          <Button variant="contained" color="primary" onClick={props.close}>
            CERRAR
          </Button>
        </div>
        {/* </ValidatorForm> */}
      </DialogContent>
    </Dialog>
  );
};
